/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Preinstall_TitleInputs */



/**
* | output |
* | --- |
* | "Pre-install thermostatic heads" |
*
* @param {Valve_Preinstall_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_preinstall_title = /** @type {((inputs?: Valve_Preinstall_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Preinstall_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-install thermostatic heads")
	return /** @type {LocalizedString} */ ("Pré-installer des têtes thermostatiques")
});